import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	INTERACTION_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';

import { ActionTrackerService } from './../../../app/services/actiontracker.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	exports: [],
	providers: [],
})
export class ShellTrackersService {
	constructor(private tracker: ActionTrackerService) {}

	trackHeaderMenuItemClick(ScopeReference, params?) {
		this.tracker.eventTracker(
			SCOPE_TYPE.Header,
			SUBSCOPE_TYPE.MenuItem,
			ScopeReference,
			INTERACTION_TYPE.Click,
			{
				...params,
			}
		);
	}
}
